function RiskMatrixField() {
  return null;
}

export default RiskMatrixField;
